import { mergeStyleSets } from '@fluentui/react';

// TODO: remove after moving to new version of FluentUI
export const useStyles = () =>{
  return mergeStyleSets({
    hubspotHome: {
      padding: '16px',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
      selectors: {
        '& .ms-layer': {
          display: 'none !important',
        }
      }
    },
    navItem: {
      margin: '0 !important',
      width: 'auto !important',
      selectors: {
        '& .ms-layer': {
          display: 'none !important',
        }
      }
    }
  })
}
